import { checkToken } from "../../utils/helper"
import { Navigate } from "react-router-dom"
import { useDispatch } from "react-redux"

function GuestOnly({ children }) {
  const dispatch = useDispatch()

  return (
    !checkToken(dispatch)?.valid ?
      children :
      <Navigate to="/" replace />
  )
}

export default GuestOnly